import { render, staticRenderFns } from "./last_medical_record.vue?vue&type=template&id=6a3e1268&scoped=true&"
import script from "./last_medical_record.vue?vue&type=script&lang=js&"
export * from "./last_medical_record.vue?vue&type=script&lang=js&"
import style0 from "./last_medical_record.vue?vue&type=style&index=0&id=6a3e1268&prod&lang=scss&"
import style1 from "./last_medical_record.vue?vue&type=style&index=1&id=6a3e1268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3e1268",
  null
  
)

export default component.exports